// Utilería pura de Archivos: sin React y sin red, para poder probarla.

export function tamano(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / 1048576).toFixed(1)} MB`;
  return `${(n / 1073741824).toFixed(2)} GB`;
}

export function cuando(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  const hoy = new Date();
  const mismoDia = d.toDateString() === hoy.toDateString();
  const ayer = new Date(hoy); ayer.setDate(hoy.getDate() - 1);
  if (mismoDia) return `hoy ${d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}`;
  if (d.toDateString() === ayer.toDateString()) return `ayer ${d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}`;
  return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: d.getFullYear() === hoy.getFullYear() ? undefined : 'numeric' });
}

export const CLASIFICACION = {
  INTERNO: { texto: 'Interno', tono: 'bg-gray-100 text-gray-700' },
  CONFIDENCIAL: { texto: 'Confidencial', tono: 'bg-amber-100 text-amber-900' },
  DATOS_PERSONALES: { texto: 'Datos personales', tono: 'bg-red-100 text-red-900' },
};

export const ESTADO_ANTIVIRUS = {
  LIMPIO: 'Revisado por el antivirus',
  REVISANDO: 'Revisando…',
  INFECTADO: 'Marcado por el antivirus',
  SIN_ANTIVIRUS: 'Sin antivirus en este servidor',
};

export function extension(nombre) {
  const n = String(nombre || '');
  return n.includes('.') ? n.split('.').pop().toLowerCase() : '';
}

/** Ordena carpetas primero y luego archivos, por nombre; o por fecha. */
export function ordenar(lista, por = 'nombre') {
  const copia = [...lista];
  if (por === 'fecha') {
    copia.sort((a, b) => String(b.actualizado_en || b.creada_en || '').localeCompare(String(a.actualizado_en || a.creada_en || '')));
  } else {
    copia.sort((a, b) => a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' }));
  }
  return copia;
}

/** La razón por la que un botón está apagado, o null si se puede. */
export function porQueNo({ permisos = [], accion, seleccion = [], soloLectura = false }) {
  const tiene = (p) => permisos.includes(p);
  if (accion === 'subir' || accion === 'nueva-carpeta') {
    if (!tiene('archivos.subir')) return 'Tu rol no sube archivos: pide el permiso «Subir y organizar archivos».';
    if (soloLectura) return 'Esta carpeta es de solo lectura.';
    return null;
  }
  if (accion === 'papelera') {
    if (!tiene('archivos.borrar')) return 'Tu rol no manda a la papelera.';
    if (!seleccion.length) return 'Selecciona algo primero.';
    return null;
  }
  if (accion === 'mover') {
    if (!tiene('archivos.subir')) return 'Tu rol no mueve archivos.';
    if (!seleccion.length) return 'Selecciona algo primero.';
    return null;
  }
  return null;
}
